import { Link } from "react-router-dom";
import { Scale } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

const NAV_LINKS = [
  { to: "/compare", label: "Compare Banks" },
  { to: "/rankings", label: "Rankings" },
  { to: "/about", label: "About" },
  { to: "/partners", label: "Partner with us" },
];

const LEGAL_LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-of-use", label: "Terms of Use" },
  { to: "/cookie-policy", label: "Cookie Policy" },
  { to: "/disclaimer", label: "Disclaimer" },
];

export const Footer = () => (
  <footer className="bg-[#0F1115] text-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <Link to="/" className="flex items-center gap-2 mb-4 w-fit">
          <Scale size={20} className="text-[#059669]" />
          <span className="font-display font-black text-xl tracking-tighter">Bankingfees.eu</span>
        </Link>
        <p className="text-sm text-white/60 leading-relaxed max-w-xs">
          Transparent banking fees, worldwide.
        </p>
        <p data-testid={FOOTER.affiliateNote} className="text-xs text-white/40 mt-4 max-w-xs">
          Now open for affiliate, advertising, and data partnerships.
        </p>
      </div>
      <div data-testid={FOOTER.navLinks}>
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40 mb-4">Navigate</p>
        <ul className="space-y-2 text-sm text-white/70">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="hover:text-white transition-colors duration-150">{l.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div data-testid={FOOTER.legalLinks}>
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40 mb-4">Legal</p>
        <ul className="space-y-2 text-sm text-white/70">
          {LEGAL_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="hover:text-white transition-colors duration-150">{l.label}</Link>
            </li>
          ))}
          <li>
            <Link to="/contact" data-testid={FOOTER.contactLink} className="hover:text-white transition-colors duration-150">Contact Us</Link>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 px-6 lg:px-10">
      <p data-testid={FOOTER.disclaimer} className="text-center text-xs sm:text-sm font-bold tracking-wide text-[#E52B50] max-w-xl mx-auto">
        Retail fees sourced from official bank websites; private banking fees are indicative estimates. Always verify directly with your bank before making decisions.
      </p>
      <p data-testid={FOOTER.copyright} className="text-center text-[11px] text-white/40 mt-3">
        © 2026 Bankingfees.eu. All rights reserved.
      </p>
    </div>
  </footer>
);
